<script setup lang="ts">
const registerSuccess = ref(false)

const signupSuccess = () => {
  registerSuccess.value = !registerSuccess.value
}
</script>

<template lang="pug">
TransitionGroup(name="fade")
  div(
    v-if="!registerSuccess"
    key="registerOptions"
  )
    h1(class="heading-2 text-gray-900") Create your free&nbsp;account
    LoginOauth
    div(class="divider") Continue with email
    RegisterForm(@onSignupSuccess="signupSuccess")

  div(
    v-else
    key="successMessage"
  )
    h2(class="heading-3") Your OpenESG registration was successful
    p(class="flex gap-6")
      MaterialSymbol(class="text-brand") check_circle
      | Please verify your account by checking your email and&nbsp;following the link.
</template>
